import { BrowserAuthManager } from "@groundspark/browser-auth";
import type { AppConfig } from "./config";

export class AuthManager extends BrowserAuthManager {
  public constructor(config: AppConfig) {
    super(config, "groundspark_branch_session_v1");
  }
}
